export function currentPathname() {
  return new URL(window.location.href).pathname
}

export function pathExact(path) {
  return currentPathname() === path
}

export function pathStartsWith(prefix) {
  return currentPathname() === prefix || currentPathname().startsWith(`${prefix}/`)
}

export function siteUuidFromPath() {
  const match = currentPathname().match(/^\/site\/([^/]+)/)
  return match ? match[1] : null
}

export function isSiteOverviewPath(siteUuid) {
  if (!siteUuid) return false
  return pathExact(`/site/${siteUuid}`)
}
